// Path: src\Components\Rewards\RewardStore\MyRewards.jsx
import React, { useCallback, useEffect, useRef, useState } from "react";
import BaseHome from "../../Home/BaseHome";
import Myntra from "../../../assets/images/myntra.png";
import Diamond from "../../../images/Diamond.png";
import { rewardCategoryList } from "../../../api/rewardCategory.api";
import { myRewardProductList } from "../../../api/rewardProduct.api";
import { url } from '../../../config/url';
import moment from "moment/moment";
import ListLoader from '../../Common/ListLoader';
export const initialFilter = {
  "pagination": {
    "pageNo": 1,
    "recordPerPage": 100,
    "sortBy": "order",
    "sortDirection": "desc"
  }
};

const MyRewards = ({ setReedemCouponPopup, setMyReedemItem }) => {
  // State to track the active tab
  const [activeTab, setActiveTab] = useState(0);
  const [filter, setFilter] = useState(initialFilter);
  const [categoryList, setCategoryList] = useState([]);
  const [categoryId, setCategoryId] = useState("");
  const [productList, setProductList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordPerPage, setRecordPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false)
  const [changeCategory, setChangeCategory] = useState(false)

  useEffect(() => {
    fetchRewardCategory();
  }, [])

  useEffect(() => {
    if (currentPage <= totalPages)
      loadMore()
  }, [currentPage])

  useEffect(() => {
    if (categoryId) {
      fetchRewardProduct()
    }
    else if (!categoryId && changeCategory === true) {
      fetchRewardProduct()
    }
  }, [categoryId])

  const loadMore = async () => {
    if (!changeCategory) {
    
      fetchRewardProduct()
 
    }
  }

  const observer = useRef();
  const lastPostElementRef = useCallback(
    async (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          setCurrentPage((prevPage) => prevPage + 1);
        }
      });

      if (node) observer.current.observe(node);
    },
    [loading]
  );

  const fetchRewardCategory = async () => {
    try {
      const res = await rewardCategoryList(filter);
      if (res?.success && res?.data) {
        let list = [{
          "index": 0,
          "_id": "",
          "name": "All",
          "img": null
        }]
        if (res?.data && res?.data?.length > 0) {
          for (let i = 0; i < res?.data?.length; i++) {
            let obj = { ...res?.data?.[i] }
            obj.index = i + 1
            list.push(obj)
          }
        }
        setCategoryList(list);
      }
      else {
        setCategoryList([]);
      }
    } catch (error) {
    }
  };

  const fetchRewardProduct = async () => {
    setLoading(true)
    try {
      let data = {
        pagination: {
          pageNo: currentPage,
          recordPerPage: recordPerPage,
          // sortBy: 'order',    for ascending order
          sortDirection: "asc"
        }
      }

      if (categoryId) {
        data.search = {
          rewardCategory: categoryId
        }
      }

      const res = await myRewardProductList(data);
      setLoading(false)
      setChangeCategory(false);
      if (res?.success && res?.data) {
        let list = []
        if (res?.data && res?.data?.length > 0) {
          for (let i = 0; i < res?.data?.length; i++) {
            let obj = { ...res?.data?.[i] }
            obj.index = i + 1
            list.push(obj)
          }
        }

        if (currentPage == 1) {
          setProductList(list);
        }
        else {
          setProductList([...productList, ...list])
        }
        setTotalPages(res?.totalPages);
      }
      else {
        setProductList([]);
      }
    } catch (error) {
      setLoading(false)
    }
  };

  const handleTabClick = (tab) => {
    setChangeCategory(true);
    setCategoryId(tab?._id || "");
    setActiveTab(tab?.index || 0);
    setCurrentPage(1);
  };

  const checkStatus = (status) => {
    if (status === "completed") {
      return (
        <span className="myrewards-status-cancelled myrewards-status-completed">
          {status}
        </span>
      );
    } else if (status === "inProcess" || status === "pending") {
      return (
        <span className="myrewards-status-cancelled myrewards-status-inprocess">
          in progress
        </span>
      );
    } else if (status === "cancelled" || status === "FAILED") {
      return (
        <span className="myrewards-status-cancelled">
          cancelled
        </span>
      );
    } else if (status === "delivered") {
      return (
        <span className="myrewards-status-cancelled myrewards-status-delivered">
          delivered
        </span>
      );
    } else {
      return (
        <span className="myrewards-status-cancelled myrewards-status-pending">
          {status}
        </span>
      );
    }
  };
  

  const handleRedeemDetails = (reward) => {
    setReedemCouponPopup(true);
    setMyReedemItem(reward);
  }

  return (
    <>
      <div className="rewardsstore-main-wrap">
        <div className="row reward-store-inner-tabs">
          <div className='reward-store-tabs-child'>
            {categoryList && categoryList?.length > 0 && categoryList.map((tab) => (
              <div
                key={tab?.index || 0}
                className={`reward-store-tabs-text ${activeTab === tab?.index || 0 ? 'active-tab' : ''}`}
                style={{ color: activeTab === tab?.index || 0 ? 'red' : 'white' }}
                onClick={() => handleTabClick(tab)}
              >
                   {/* <span>
                  {tab?.name?.length > 6 ? (
                    <marquee>{tab?.name.toLowerCase()}</marquee>
                  ) : (
                    tab?.name.toLowerCase()
                  )}
                </span> */}
                <span>{tab?.name?.toLowerCase()}</span> 
              </div>
            ))}
          </div>
        </div>

        {/* Display reward cards based on activeTab */}
        <div className={`myreward-card-wrap ${
    productList?.length > 0 ? 'w-94' : 'w-100'
  }`}>
          {productList?.length > 0 ? productList.map((reward, index) => (
            <div className="myrewards-card" key={index} ref={productList?.length === index + 1 ? lastPostElementRef : null} onClick={() => handleRedeemDetails(reward)}>
              {/* Left SVG */}
              <div className="myrewards-svg-left">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="28"
                  height="28"
                  viewBox="0 0 28 28"
                  fill="none"
                >
                  <circle cx="14" cy="14" r="14" fill="#111622" />
                </svg>
              </div>

              <div className="myrewards-card-content">
                <div className="myrewards-logo">
                  <img src={url?.IMAGE_URL + reward?.img?.default} alt={reward?.name} />
                </div>
                <div className="myrewards-dashed-line"></div>
                <div className="myrewards-details">
                  <div className="myrewards-details-dflex">
                    <h4 className="myrewards-title ">
                    {reward?.name?.length > 9 ? (
                        <marquee>  {reward?.name}</marquee>
                      ) : (
                        reward?.name
                      )}
                      {/* {reward?.name} */}
                      </h4>
                    <p className="myrewards-price">
                   
                      
                        {reward?.voucherInfo?.currency?.code === "INR" ?<>
                          <span className="me-1">{reward?.voucherInfo?.currency?.symbol}</span>
                          {reward?.voucherInfo?.amount}
                          </>
                          
                          :
                          <>
                          {" " + reward?.voucherInfo?.amount}
                          <span className="ms-1">
                             <img className='rewardstore-img-icon-size' src={url?.IMAGE_URL + reward?.voucherInfo?.currency?.img?.default} alt={reward?.name} /> 
                          </span>
                          </>
                          
                        }                      
                    </p>
                  </div>
                  <p className="myrewards-points">
                    {reward?.redeemInfo?.amount}{" "}
                    <span className="myrewards-icon">
                      {reward?.redeemInfo?.currency?.code === "INR" ?
                        reward?.redeemInfo?.currency?.symbol
                        :
                        <img className='rewardstore-img-icon-size mb-1' src={url?.IMAGE_URL + reward?.redeemInfo?.currency?.img?.default} alt={reward?.name} />
                      }
                    </span>
                  </p>
                </div>
                <div className="myrewards-dflex">
                  <div className="myrewards-status">
                  {checkStatus(reward?.deliveryStatus)}
                  </div>
                  <p className="myrewards-date">{moment(reward?.createdAt).format("DD/MM/YYYY, hh:mmA")}</p>
                </div>
              </div>

              {/* Right SVG */}
              <div className="myrewards-svg-right">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="28"
                  height="28"
                  viewBox="0 0 28 28"
                  fill="none"
                >
                  <circle cx="14" cy="14" r="14" fill="#111622" />
                </svg>
              </div>
            </div>
          )) : !loading &&  <> <div className='no-record-found-center-rewards'><span className="text-center">no data found</span></div></>}
          {loading && <div className='w-100 d-flex justify-content-center'> <ListLoader/></div>}
        </div>
      </div>
    </>
  );
};

export default MyRewards;
